export interface Position {
  x: number;
  y: number;
}
